{
  "header": {
    "name": "Nome"
  },
  "empty": "Non è stata trovata nessuna rete",
  "button": {
    "new": "Nuova rete",
    "newSub": "Aggiungere una sotto-rete",
    "update": "Modificare la rete",
    "remove": "Eliminare la rete"
  },
  "label": "rete",
  "validation": {
    "required": "Campo richiesto",
    "maxLength": "Lunghezza massima: {maxLength}",
    "nameFormat": "Il nome deve contenere i seguenti caratteri [a-zA-Z0-9 _.-]",
    "minLength": "Lunghezza minima: {minLength}"
  },
  "details": {
    "tab": {
      "device": {
        "label": "Stazione locale S4"
      },
      "application": {
        "label": "Applicazioni"
      },
      "user": {
        "label": "Utenti"
      },
      "userGroup": {
        "label": "Gruppi utenti"
      },
      "dtwins": {
        "label": "Apparati"
      },
      "sectors": {
        "label": "Settori"
      }
    },
    "buttons": {
      "create": "Nuova rete",
      "createSubSector": "Aggiungi sotto-rete",
      "remove": "Rimuovi la rete",
      "attach": {
        "application": "Collegare un’applicazione",
        "device": "Collegare un apparato",
        "user": "Collegare un utente",
        "userGroup": "Collegare un gruppo utenti",
        "dtwins": "Collegare un apparato"
      },
      "detach": "Rimuovere dalla rete",
      "details": "Dettagli"
    },
    "currentSelection": "Selezione attuale"
  },
  "modals": {
    "create": {
      "title": "Creare una nuova rete",
      "sector": {
        "label": "Nome della rete",
        "description": "Descrizione"
      }
    },
    "update": {
      "title": "Aggiornare una rete",
      "sector": {
        "label": "Nome della rete",
        "description": "Descrizione"
      }
    },
    "remove": {
      "title": "Eliminazione della rete {sectorName}",
      "description": "Sei sicuro di voler eliminare questa rete?",
      "notAllowed": "Non è possibile effettuare l’eliminazione di una rete, alcuni apparati sono collegati ad essa",
      "titleAlt": "Elimina la rete"
    },
    "confirmDetach": {
      "device": {
        "title": "Scollegamento dell’apparato da una rete",
        "description": "L’apparato \"{name}\" sarà scollegato dalla rete \"{sectorLabel}\" | I seguenti apparati saranno scollegati dalla rete \"{sectorLabel}\"",
        "warning": "L’apparato scollegato da tutte le reti non verrà più visualizzato sugli schermi di gestione (secondo i diritti utente). | Gli apparati scollegati da tutte le reti non verranno più visualizzati sugli schermi di gestione (secondo i diritti utente)."
      },
      "application": {
        "title": "Scollegamento dell’applicazione da una rete",
        "description": "L’applicazione \"{name}\" sarà scollegata dalla rete \"{sectorLabel}\" | Le seguenti applicazioni saranno scollegate dalla rete \"{sectorLabel}\"",
        "warning": "L’applicazione scollegata da tutte le reti non verrà più visualizzata sugli schermi di gestione (secondo i diritti utente). | Le applicazioni scollegate da tutte le reti non verranno più visualizzate sugli schermi di gestione (secondo i diritti utente)."
      },
      "user": {
        "title": "Scollegamento di un utente da una rete",
        "description": "L’utente \"{name}\" sarà scollegato dalla rete \"{sectorLabel}\" | I seguenti utenti saranno scollegati dalla rete \"{sectorLabel}\"",
        "warning": "L’utente scollegato da tutte le reti non potrà più accedere alla visualizzazione e alla gestione degli apparati/applicazioni. | Gli utenti scollegati da tutte le reti non potranno più accedere alla visualizzazione e alla gestione degli apparati/applicazioni."
      },
      "userGroup": {
        "title": "Scollegamento di un gruppo utenti da una rete",
        "description": "Il gruppo utenti \"{name}\" sarà scollegato dalla rete \"{sectorLabel}\" | I seguenti gruppi utenti saranno scollegati dalla rete \"{sectorLabel}\"",
        "warning": "Il gruppo utenti scollegato da tutte le reti non potrà più accedere alla visualizzazione e alla gestione degli apparati/applicazioni. | I gruppi utenti scollegati da tutte le reti non potranno più accedere alla visualizzazione e alla gestione degli apparati/applicazioni."
      },
      "errors": {
        "list_empty": "È necessario selezionare almeno un elemento da scollegare"
      },
      "dtwins": {
        "title": "Scollegamento dell’apparato da una rete",
        "description": "L’apparato \"{name}\" sarà scollegato dalla rete \"{sectorLabel}\" | I seguenti apparati saranno scollegati dalla rete \"{sectorLabel}\"",
        "warning": "L’apparato scollegato da tutte le reti non verrà più visualizzato sugli schermi di gestione (secondo i diritti utente). | Gli apparati scollegati da tutte le reti non verranno più visualizzati sugli schermi di gestione (secondo i diritti utente)."
      }
    },
    "attach": {
      "device": {
        "title": "Ricollegare gli apparati a una rete",
        "description": "Selezionare gli apparati da ricollegare alla rete"
      },
      "application": {
        "title": "Ricollegare delle applicazioni a una rete",
        "description": "Selezionare le applicazioni da ricollegare alla rete"
      },
      "user": {
        "title": "Ricollegare gli utenti a una rete",
        "description": "Selezionare gli utenti da ricollegare alla rete"
      },
      "userGroup": {
        "title": "Ricollegare i gruppi utenti a una rete",
        "description": "Selezionare i gruppi utenti da ricollegare alla rete"
      },
      "errors": {
        "list_empty": "È necessario selezionare almeno un elemento da collegare"
      },
      "dtwins": {
        "description": "Selezionare gli apparati da ricollegare alla rete",
        "title": "Ricollegare gli apparati a una rete"
      }
    },
    "view": {
      "title": "Visualizza un settore"
    }
  },
  "search": "Ricerca per nome",
  "filters": {
    "information": "Selezionare le proprie reti di lavoro. Ciò determinerà gli elementi che l’utente potrà gestire in tutti gli schermi LX CONNECT."
  },
  "select": {
    "all": "Seleziona tutti i reti",
    "selected": "reti selezionate"
  },
  "treeview": {
    "actionsButton": {
      "title": "Azioni"
    }
  },
  "selectedUsers": "Nessun utente selezionato | {count} utente selezionato | {count} utenti selezionati",
  "selectedUserGroups": "Nessun gruppo selezionato | {count} gruppo selezionato | {count} gruppi selezionati"
}
